export function* saveCoupon(action: any): any {
  yield call(sagaFunction, action, CallApi.POST, API_URL.EVENT.SAVE_COUPON, action.payload, true);
}
import { call } from "redux-saga/effects";
import { ACTIONS, API_URL, APPLICATION_GLOBAL_SLUG, sagaFunction } from "../_config";
import { CallApi } from "./api/callApi";

export function* getRodeoEventEvents(action: any): any {
  const yieldPuts = [{ type: ACTIONS.EVENT.RODEO_EVENT_EVENTS }];
  yield call(sagaFunction, action, CallApi.GET, API_URL.EVENT.RODEO_EVENT_EVENTS, action.payload, true, yieldPuts);
}

export function* postRodeoEventUserPick(action: any): any {
  const yieldPuts = [{ type: ACTIONS.EVENT.RODEO_EVENT_USER_PICK }];
  yield call(sagaFunction, action, CallApi.POST, API_URL.EVENT.RODEO_EVENT_USER_PICK, action.payload, true, yieldPuts);
}

export function* getRodeoEventYourPicks(action: any): any {
  const yieldPuts = [{ type: ACTIONS.EVENT.RODEO_EVENT_YOUR_PICKS }];
  yield call(sagaFunction, action, CallApi.GET, API_URL.EVENT.RODEO_EVENT_YOUR_PICKS, action.payload, true, yieldPuts);
}

export function* getGroups(action: any): any {
  const yieldPuts = [{ type: ACTIONS.EVENT.GROUPS }];
  yield call(sagaFunction, action, CallApi.GET, API_URL.EVENT.GROUPS, action.payload, true, yieldPuts);
}

export function* getRodeoEvents(action: any): any {
  const yieldPuts = [{ type: ACTIONS.EVENT.RODEO_EVENTS }];
  yield call(
    sagaFunction,
    action,
    CallApi.GET,
    API_URL.EVENT.RODEO_EVENTS + action.payload.groupId,
    null,
    true,
    yieldPuts,
  );
}

export function* getPastRodeoEvents(action: any): any {
  const yieldPuts = [{ type: ACTIONS.EVENT.PAST_RODEO_EVENTS }];
  yield call(sagaFunction, action, CallApi.GET, API_URL.EVENT.PAST_RODEO_EVENTS, action.payload, true, yieldPuts);
}

export function* getUpcomingEvents(action: any): any {
  const yieldPuts = [{ type: ACTIONS.EVENT.RODEO_EVENTS }];
  yield call(sagaFunction, action, CallApi.GET, API_URL.EVENT.UPCOMING_EVENTS, action.payload, true, yieldPuts);
}

export function* getPerformances(action: any): any {
  const yieldPuts = [{ type: ACTIONS.EVENT.PERFORMANCES }];
  yield call(
    sagaFunction,
    action,
    CallApi.GET,
    API_URL.EVENT.PERFORMANCES + action.payload.rodeoEventId,
    action.payload,
    true,
    yieldPuts,
  );
}

export function* getEvents(action: any): any {
  const yieldPuts = [{ type: ACTIONS.EVENT.EVENTS }];
  yield call(
    sagaFunction,
    action,
    CallApi.GET,
    API_URL.EVENT.EVENTS + action.payload.performanceId,
    action.payload,
    true,
    yieldPuts,
  );
}

export function* pickRider(action: any): any {
  yield call(sagaFunction, action, CallApi.POST, API_URL.EVENT.PICK_RIDER, action.payload, true);
}

export function* getGameDetails(action: any): any {
  const yieldPuts = [{ type: ACTIONS.EVENT.GAME_DETAILS, payload: "game_details" }];
  yield call(
    sagaFunction,
    action,
    CallApi.GET,
    API_URL.GAME_DETAILS + APPLICATION_GLOBAL_SLUG,
    action.payload,
    true,
    yieldPuts,
  );
}

export function* getMyTeam(action: any): any {
  yield call(sagaFunction, action, CallApi.GET, API_URL.EVENT.MY_TEAM + action.payload.rodeoEventId, null, true);
}

export function* getYourPicks(action: any): any {
  yield call(
    sagaFunction,
    action,
    CallApi.GET,
    API_URL.EVENT.YOUR_PICKS + action.payload.performanceId,
    action.payload,
    true,
  );
}

export function* winningTicketResults(action: any): any {
  yield call(
    sagaFunction,
    action,
    CallApi.GET,
    API_URL.EVENT.MY_CORRECT_PICKS + action.payload.rodeoEventId,
    null,
    true,
  );
}

export function* applyLeagueCode(action: any): any {
  yield call(sagaFunction, action, CallApi.POST, API_URL.EVENT.APPLY_LEAGUE_CODE, action.payload, true);
}

export function* getShareImageLink(action: any): any {
  yield call(sagaFunction, action, CallApi.POST, API_URL.EVENT.GET_SHARE_IMAGE_LINK, action.payload, true);
}

export function* getMostPopularPicks(action: any): any {
  yield call(sagaFunction, action, CallApi.GET, API_URL.EVENT.MOST_POPULAR_PICKS, action.payload, true);
}

export function* getGroupLeaderboard(action: any): any {
  yield call(sagaFunction, action, CallApi.GET, API_URL.EVENT.GROUP_LEADER_BOARD + action.payload.groupId, null, true);
}

export function* getLeaderboard(action: any): any {
  yield call(sagaFunction, action, CallApi.GET, API_URL.EVENT.LEADERBOARD, action.payload, true);
}

export function* getLeagueLeaderboard(action: any): any {
  yield call(
    sagaFunction,
    action,
    CallApi.GET,
    API_URL.EVENT.LEAGUE_LEADERBOARD + action.payload.performanceId + "/" + action.payload.code,
    null,
    true,
  );
}

export function* getVsLeagueLeaderboard(action: any): any {
  yield call(sagaFunction, action, CallApi.GET, API_URL.EVENT.VS_LEAGUE_LEADERBOARD + action.payload.code, null, true);
}

export function* tvImage(action: any): any {
  const yieldPuts = [{ type: ACTIONS.EVENT.TV_IMAGE }];
  yield call(sagaFunction, action, CallApi.GET, API_URL.EVENT.TV_IMAGE, action.payload, true, yieldPuts);
}
export function* groupTvImageDetails(action: any): any {
  try {
    const data = action.payload;
    const resp = yield call(CallApi.GET, API_URL.EVENT.GROUP_TV_IMAGE_DETAILS, data);
    if (resp.status >= 200 && resp.status < 300 && resp.data && resp.data.data) {
      action && action.callbackSuccess && action.callbackSuccess(resp.data);
    } else {
      action && action.callbackError && action.callbackError(resp.data);
    }
  } catch (e: any) {
    action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
  }
}

export function* getActivePerformances(action: any): any {
  const yieldPuts = [{ type: ACTIONS.EVENT.ACTIVE_PERFORMANCES }];
  yield call(sagaFunction, action, CallApi.GET, API_URL.EVENT.ACTIVE_PERFORMANCES, action.payload, true, yieldPuts);
}

export function* getCategorizedPerformances(action: any): any {
  const yieldPuts = [{ type: ACTIONS.EVENT.CATEGORIZED_PERFORMANCES }];
  yield call(
    sagaFunction,
    action,
    CallApi.GET,
    API_URL.EVENT.CATEGORIZED_PERFORMANCES,
    action.payload,
    true,
    yieldPuts,
  );
}

export function* getCategorizedRodeoEvents(action: any): any {
  const yieldPuts = [{ type: ACTIONS.EVENT.CATEGORIZED_RODEO_EVENTS }];
  yield call(
    sagaFunction,
    action,
    CallApi.GET,
    API_URL.EVENT.CATEGORIZED_RODEO_EVENTS,
    action.payload,
    true,
    yieldPuts,
  );
}

export function* getCategorizedEventGroups(action: any): any {
  const yieldPuts = [{ type: ACTIONS.EVENT.CATEGORIZED_EVENT_GROUPS }];
  yield call(
    sagaFunction,
    action,
    CallApi.GET,
    API_URL.EVENT.CATEGORIZED_EVENT_GROUPS,
    action.payload,
    true,
    yieldPuts,
  );
}

export function* getEventGroupsLeaderboard(action: any): any {
  const yieldPuts = [{ type: ACTIONS.EVENT.EVENT_GROUPS_LEADERBOARD }];
  yield call(
    sagaFunction,
    action,
    CallApi.GET,
    API_URL.EVENT.EVENT_GROUPS_LEADERBOARD,
    action.payload,
    true,
    yieldPuts,
  );
}

export function* getRodeoLeaderboard(action: any): any {
  const yieldPuts = [{ type: ACTIONS.EVENT.RODEO_LEADERBOARD }];
  yield call(sagaFunction, action, CallApi.GET, API_URL.EVENT.RODEO_LEADERBOARD, action.payload, true, yieldPuts);
}

export function* getPerformanceLeaderboard(action: any): any {
  const yieldPuts = [{ type: ACTIONS.EVENT.PERFORMANCE_LEADERBOARD }];
  yield call(sagaFunction, action, CallApi.GET, API_URL.EVENT.PERFORMANCE_LEADERBOARD, action.payload, true, yieldPuts);
}

export function* getSidebarPerformanceLeaderboard(action: any): any {
  const yieldPuts = [{ type: ACTIONS.EVENT.SIDEBAR_PERFORMANCE_LEADERBOARD }];
  yield call(sagaFunction, action, CallApi.GET, API_URL.EVENT.PERFORMANCE_LEADERBOARD, action.payload, true, yieldPuts);
}

export function* getSidebarRodeoLeaderboard(action: any): any {
  const yieldPuts = [{ type: ACTIONS.EVENT.SIDEBAR_RODEO_LEADERBOARD }];
  yield call(sagaFunction, action, CallApi.GET, API_URL.EVENT.RODEO_LEADERBOARD, action.payload, true, yieldPuts);
}

export function* getSidebarEventGroupsLeaderboard(action: any): any {
  const yieldPuts = [{ type: ACTIONS.EVENT.SIDEBAR_EVENT_GROUPS_LEADERBOARD }];
  yield call(
    sagaFunction,
    action,
    CallApi.GET,
    API_URL.EVENT.EVENT_GROUPS_LEADERBOARD,
    action.payload,
    true,
    yieldPuts,
  );
}

export function* getMyPickList(action: any): any {
  const yieldPuts = [{ type: ACTIONS.EVENT.MY_PICK_LIST }];
  yield call(sagaFunction, action, CallApi.GET, API_URL.EVENT.MY_PICK_LIST, action.payload, true, yieldPuts);
}

export function* getWinningTicketResults(action: any): any {
  yield call(sagaFunction, action, CallApi.GET, API_URL.EVENT.WINNING_TICKET_RESULTS, action.payload, true);
}
